import React from "react";
import { withRouter } from "react-router";
import NuevaCadeteria from "../NuevaCadeteria";
const EditarInformacionCadeteria = props => {
  return <NuevaCadeteria edit={true} id={props.match.params.id} />;
};
export default withRouter(EditarInformacionCadeteria);
